import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { RevisitPyqDialogComponent } from '../revisit-pyq-dialog/revisit-pyq-dialog.component';

@Component({
  selector: 'app-pyq-chapter-completion',
  templateUrl: './pyq-chapter-completion.component.html',
  styleUrls: ['./pyq-chapter-completion.component.css']
})
export class PyqChapterCompletionComponent implements OnInit {
  topicCardList:any = [];
  disableNextTopic:boolean = false;
  constructor(public router:Router, public selfLearnService:SelfLearnService, public dialog: MatDialog,) { }


  ngOnInit(): void {
    localStorage.removeItem('showAnseredQuestions');
  }
navigateToChapterPractice(){
  this.router.navigate(['selfLearn-V2/chapter'])
}
goToPracticeModule(){
this.router.navigate(['selfLearn-V2/chapter'])
}
revisitQuestions(){

  const config: MatDialogConfig = {
     width: '620px',
    //  height:'30%',
    panelClass: ['qiut-practice-modal', 'mweb-stiky-bottom'],
    data: {
    },
    
  };
  this.dialog.open(RevisitPyqDialogComponent, config);
}
getTopicName(){
  return this.selfLearnService.getChapterName();
}
}
